import { Column, Row, Typography } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import React from 'react';
import PropTypes from 'prop-types';

import FixedRatioImage from '../shared/FixedRatioImage';

export const PendingItemSummary = ({ pendingItemSummary }) => {
  const [cartMessages] = useTranslations(['cartMessages']);
  return (
    <Row>
      <Column span={4} spanXs={4}>
        <FixedRatioImage
          src={pendingItemSummary.livePreviewUrl}
          alt={pendingItemSummary.productDisplayName}
        />
      </Column>
      <Column span={8} spanXs={8}>
        <Typography fontSize={3} fontWeight="bold">
          {pendingItemSummary.productDisplayName}
        </Typography>
        <Typography mt={2}>
          {cartMessages.quantity}: {pendingItemSummary.quantity}
        </Typography>
      </Column>
    </Row>
  );
};

PendingItemSummary.propTypes = {
  pendingItemSummary: PropTypes.objectOf({
    livePreviewUrl: PropTypes.string,
    productDisplayName: PropTypes.string,
    quantity: PropTypes.number,
  }).isRequired,
};
